import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sales-pos',
  templateUrl: './sales-pos.component.html',
  styleUrls: ['./sales-pos.component.css']
})
export class SalesPosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
